// Import Core
import React from "react";
import styled from "styled-components";

const LoaderStyles = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 75vh;
  width: 100%;
  background-color: var(--neutral-200);

  .loader-18 {
    position: relative;
    &:before,
    &:after {
      content: '';
      display: block;
      position: absolute;
      border-radius: 50%;
      border: .15em solid transparent;
      border-bottom-color: var(--primary);
      top: 0;
      left: 0;
      animation: 1s loader-18 linear infinite;
    }
    &:before {
      width: 2em;
      height: 2em;
    }
    &:after {
      width: 1.6em;
      height: 1.6em;
      top: .2em;
      left: .2em;
      animation-direction: reverse;
    }
  }

  @keyframes loader-18 {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Loader = () => {
  return (
    <LoaderStyles>
      <div className="loader-18"></div>
    </LoaderStyles>
  );
};

export default Loader;